import SectionHeading from "./SectionHeading";
import { roles } from "@/mocks/home";

export default function RoleArchetypes() {
  return (
    <section id="roles" className="section-anchor bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="ROLE ARCHETYPES"
          title="六种角色原型与他们的立场"
          desc="同一段关系里，每个人的行为逻辑并不相同。先认清角色所处的位置，才能读懂他们在场景中的每一个选择。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {roles.map((role) => (
            <article
              key={role.name}
              className="group rounded-lg border border-background-200 bg-background-100/70 p-5 md:p-6 transition-colors hover:border-primary-300 hover:bg-background-100"
            >
              <div className="flex items-start justify-between">
                <span className="w-12 h-12 rounded-lg flex items-center justify-center bg-primary-500/15 text-primary-700">
                  <i className={`${role.icon} text-2xl`} />
                </span>
                <span className="px-3 py-1 rounded-full bg-accent-100 text-accent-900 font-label text-xs">
                  {role.stance}
                </span>
              </div>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">
                {role.name}
              </h3>
              <p className="mt-2.5 text-sm leading-7 text-foreground-600">{role.desc}</p>
              <div className="mt-4 flex flex-wrap gap-2 border-t border-background-200 pt-4">
                {role.traits.map((trait) => (
                  <span
                    key={trait}
                    className="px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-900 font-label text-xs"
                  >
                    {trait}
                  </span>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}